import { Storage } from '@ionic/storage';
import { Injectable } from "@angular/core";
import { AppPreferences, Preference } from '../../shared/local/app-preferences.local';
import { StoragePathProvider } from '../../providers/storage-path/storage-path';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { GDAuthInterface } from '../../model/gd-auth';
import { FcmServiceProvider, FcmAddUserMultiAccountDto } from '../../providers/fcm-service/fcm-service';
import { MultipleAccount } from '../../shared/nestjs/gd-only/dto/multiple-acocunt.dto';
import { Platform } from 'ionic-angular';
import { AuthenticationBloc } from './authentication.bloc';

export interface SwitchAccountResponse {
	authHasUpdate: GDAuthInterface,
	authBeforeUpdate: GDAuthInterface,
	saasBeforeUpdate: any,
	saasHasUpdate: any,
	accountToSwitch: MultipleAccount
}

@Injectable()
export class MultipleAccountBloc {
	public accountChanged = new Subject()
	constructor(
		private storage: Storage,
		private appPreferences: AppPreferences,
		private storagePathProvider: StoragePathProvider,
		private http: HttpClient,
		private fcmServiceProvider: FcmServiceProvider,
		private platform: Platform,
		private authenticationBloc: AuthenticationBloc,
	) {

	}

	async MultipleAccount() {
		try {
			const multipleAccount = await this.checkDuplicateData()
			return multipleAccount;
		} catch (error) {
			console.log(error);
			return [];
		}
	}

	async checkDuplicateData() {
		try {
			await this.storage.ready();
			const auth = await this.appPreferences.getAuth();
			const multipleAccount = await this.appPreferences.getMultipleAccount() || [];
			let data: any[] = []

			for (let item of multipleAccount) {
				if ((item.empId !== auth.empId) || (auth.empId === item.empId && auth.companyCode !== item.companyCode)) {
					data.push(item);
				}
			}

			data = this.distinctArray(data)
			await this.appPreferences.setMultipleAccount(data);
			return data;
		} catch (error) {
			console.log(error);
			return [];
		}
	}

	async updateListAccount() {
		const accountList: MultipleAccount[] = [];
		const tempData: MultipleAccount[] = [];
		const tempAccount = await this.getTempAccount();
		const accountListStorage = await this.appPreferences.getMultipleAccount() || [];
		const authEmail = this.appPreferences.dataAuth.email;
		const authCompanyCode = this.appPreferences.dataAuth.companyCode;
		const authEmpId = this.appPreferences.dataAuth.empId;
		let dataExists = false;

		console.log('tempAccount', tempAccount);
		console.log('accountListStorage', accountListStorage);

		// check data sudah ada di list account atau belum
		if (tempAccount) {
			if (accountListStorage.length) {
				dataExists = accountListStorage.some(item => item.email === tempAccount.email
					&& item.empId === tempAccount.empId
					&& item.companyCode === tempAccount.companyCode);
			} else {
				dataExists = authEmail === tempAccount.email && authEmpId === tempAccount.empId && authCompanyCode === tempAccount.companyCode;
			}

			// menambahkan data yang baru login
			if (!dataExists) {
				accountListStorage.push(tempAccount);
			}
		}

		// hapus duplicate data
		if (accountListStorage.length) {
			for (const item of accountListStorage) {
				const findIdx = tempData.findIndex(fi => fi.email === item.email && fi.empId === item.empId && fi.companyCode === item.companyCode);
				if (findIdx === -1) {
					tempData.push(item);
				}
			}
		}

		// filter account list dengan akun yang login sekarang;
		for (const item of tempData) {
			const companyCode = item.companyCode.split('-');
			if (item.email === authEmail && companyCode[0] === authCompanyCode && item.empId === authEmpId) {
				continue;
			} else {
				accountList.push(item);
			}
		}

		return this.appPreferences.setMultipleAccount(accountList);
	}

	async setTempAccount(data: GDAuthInterface) {
		console.log('setTempAccount', data);

		if (data) {
			try {
				let pathPhoto = '';
				const companyCode = data.saasData && data.saasData.MODE.length
					? data.saasData.ACCOUNT + '-' + data.saasData.MODE[0]
					: data.saasData.ACCOUNT;

				try {
					let photopath: string = data.empphotopath || null;
					if (photopath) {
						/** hapus &nosquare jika path tidak terdapat path inisial getimage& */
						if (photopath.indexOf('getimage&') == -1) {
							data.photo = data.photo.replace("&nosquare", "");
						}
						pathPhoto = encodeURI(photopath + data.photo);
					} else {
						const storagePath = await this.storagePathProvider.getStorageProfileCustom(data.userId);
						pathPhoto = this.storagePathProvider.getUrlDownload(storagePath.urlDownload, data.photo);
					}
				} catch (error) {
					console.log(error);
				}

				const account: MultipleAccount = {
					id: data.id,
					fullName: data.fullName,
					pathPhoto: pathPhoto,
					empId: data.empId,
					userId: data.userId,
					email: data.email,
					companyCode,
					companyName: data.saasData && data.saasData.ACCOUNTNAME ? data.saasData.ACCOUNTNAME : '',
					positionName: data.position,
					gopathNew: data.saasData && data.saasData.GOPATHNEW ? data.saasData.GOPATHNEW : '',
				};

				console.log('GDSwitchAccountTemp1')
				return this.appPreferences.setGreatdayStorage(Preference.GDSwitchAccountTemp, account);
			} catch (error) {
				console.log('error', error);
				return this.appPreferences.setGreatdayStorage(Preference.GDSwitchAccountTemp, null);
			}
		} else {
			console.log('GDSwitchAccountTemp2')
			return this.appPreferences.setGreatdayStorage(Preference.GDSwitchAccountTemp, null);
		}
	}

	getTempAccount() {
		return this.appPreferences.getGreatdayStorage<MultipleAccount>(Preference.GDSwitchAccountTemp);
	}

	getListAccount() {
		return this.appPreferences.getGreatdayStorage<MultipleAccount[]>(Preference.MultipleAccount);
	}

	async switch(item: MultipleAccount) {
		try {
			await this.setTempAccount(this.appPreferences.dataAuth);

			// Clear session storage before account switched
			sessionStorage.clear();
			await this.authenticationBloc.switchAccount(item);
			await this.updateListAccount();
			return true;
		} catch (error) {
			console.log('switch error', error);
			throw error;
		}
	}

	async switchAccount(params: { empId: string, token: string, companyCode: string, isFromLogin?: boolean }) {
		try {
			await this.storage.ready();
			const auth = await this.appPreferences.getAuth();
			const saas = await this.appPreferences.getSaasData();

			// temporary auth data
			const authTemp = await this.appPreferences.getAuth();
			// temporary saas data
			const saasTemp = await this.appPreferences.getSaasData();

			// ubah data auth dan saas dari storage
			auth.id = params.token;
			auth.companyCode = params.companyCode;
			saas.storedPrelogin.IST = params.companyCode;

			localStorage.setItem('$account_code_login', params.companyCode)

			// set data hasil perubahan ke storage
			await this.appPreferences.setSaasData(saas);
			await this.appPreferences.setAuth(auth);

			const response = {
				authHasUpdate: auth,
				authBeforeUpdate: authTemp,
				saasBeforeUpdate: saasTemp,
				saasHasUpdate: saas,
				accountToSwitch: params
			}

			return response;
		} catch (error) {
			throw error;
		}
	}

	distinctArray(data: any[]): Array<any> {
		let result = [];
		for (const item of data) {
			const empIdExist = result.some(val => val.empId === item.empId)
			const compCodeExist = result.some(val => val.companyCode === item.companyCode)

			if (!empIdExist) {
				result.push(item);
			} else if (empIdExist && !compCodeExist) {
				result.push(item);
			}
		}

		return result;
	}

	async isMultipleAccount() {
		const account = await this.appPreferences.getMultipleAccount();
		if (account && account.length) {
			return true;
		}
		return false
	}

	async clearAccount(baseUrl, token) {
		try {
			const headers = new HttpHeaders({
				'Authorization': token
			});
			await this.http.post(`${baseUrl}/auth/logout`, {}, { headers }).toPromise();
		} catch (error) {
			// console.log('TCL: error clear account', error);
		}
	}

	// Rollback switch account jika gagal login
	async rollBackSwitchAccount(data: { authBeforeUpdate, saasBeforeUpdate }) {
		await this.appPreferences.setSaasData(data.saasBeforeUpdate);
		await this.appPreferences.setAuth(data.authBeforeUpdate);
	}

	// update storage multiple account
	async updateStorageMultipleAccount(data: { accountToSwitch: MultipleAccount, authBeforeUpdate: GDAuthInterface, saasBeforeUpdate }) {
		try {
			let dataMultiple: any = {};
			const multipleAccount = await this.appPreferences.getMultipleAccount() || [];
			const idx = multipleAccount.findIndex(i => i.empId == data.accountToSwitch.empId && i.companyCode == data.accountToSwitch.companyCode);

			// hapus akun yang akan diaktifkan dari storage
			if (idx !== -1) {
				multipleAccount.splice(idx, 1);
			}

			// tambah akun baru ke storage  multipleAccount
			if (data.authBeforeUpdate.id && data.authBeforeUpdate.empId) {
				dataMultiple.id = data.authBeforeUpdate.id;
				dataMultiple.fullName = data.authBeforeUpdate.fullName;
				dataMultiple.empId = data.authBeforeUpdate.empId
				dataMultiple.companyName = data.authBeforeUpdate.multiCompany.companyList[0].companyName || '';
				dataMultiple.positionName = data.authBeforeUpdate.position;
				dataMultiple.companyCode = data.saasBeforeUpdate.storedPrelogin.IST;
				dataMultiple.gopathNew = data.authBeforeUpdate.saasData.GOPATHNEW;
				try {
					let photopath: string = data.authBeforeUpdate.empphotopath || null;
					if (photopath) {
						/** hapus &nosquare jika path tidak terdapat path inisial getimage& */
						if (photopath.indexOf('getimage&') == -1) {
							data.authBeforeUpdate.photo = data.authBeforeUpdate.photo.replace("&nosquare", "");
						}
						dataMultiple.pathPhoto = encodeURI(photopath + data.authBeforeUpdate.photo);
					} else {
						const storagePath = await this.storagePathProvider.getStorageProfileCustom(data.authBeforeUpdate.userId);
						dataMultiple.pathPhoto = this.storagePathProvider.getUrlDownload(storagePath.urlDownload, data.authBeforeUpdate.photo);
					}
				} catch (error) {
					dataMultiple.pathPhoto = "";
				}

				multipleAccount.push(dataMultiple);
			}

			console.log('TCL: updateStorageMultipleAccount', multipleAccount);
			await this.appPreferences.setMultipleAccount(multipleAccount);
		} catch (error) {
			// console.log('TCL: error updateStorageMultipleAccount', error);
		}
	}

	async fcmRegisterToken(accountToSwitch: { empId: string, companyCode: string }) {
		if (this.platform.is('cordova')) {
			try {
				let multipleAccount = await this.appPreferences.getMultipleAccount();
				let deleteToken = [];

				// push data deleted token
				for (let account of multipleAccount) {
					if (account.empId != accountToSwitch.empId) {
						let data = {
							employee_id: account.empId,
							company_code: account.companyCode
						}
						deleteToken.push(data)
					}
				}

				const body: FcmAddUserMultiAccountDto = {
					registerToken: {
						company_code: accountToSwitch.companyCode,
						employee_id: accountToSwitch.empId
					},
					deleteToken: deleteToken
				}
				// console.log('TCL: multiaccount fcmRegisterToken ', deleteToken);
				await this.fcmServiceProvider.addUserMultiAccount(body)
			} catch (error) {
				// console.log('TCL: fcmRegisterToken error', error);
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/bloc/authentication/multiple-account.bloc.ts